import { call, put, select } from 'redux-saga/effects';
import { urls } from '../../../common/urls';
import { getHttp, getHttpwithtoken, postHttpwithtoken } from '../../../common/ApiCall';
import {
  driverOnCallPackageFailure,
  driverOnCallPackageLoading,
  driverOnCallPackageSuccess,
  drivingOnCallPackageBuyFailure,
  drivingOnCallPackageBuyLoading,
  drivingOnCallPackageBuySuccess,
  customerCallListFailure,
  customerCallListLoading,
  customerCallListSuccess,
} from '../../ducks/DriverOnCallSlice';

// Driver On Call Package Handler
export function* handlerDriverOnCallPackage(action: any): Generator<any, void, any> {
  try {
    yield put(driverOnCallPackageLoading());
    const url = `${urls.baseURL}${urls.driverOnCallPackage}`;
    console.log('Fetching driver packages from:', url);
    const response: any = yield call(getHttpwithtoken, url);
    
    console.log('Driver package API response:', response);
    
    if (response.success) {
      yield put(driverOnCallPackageSuccess(response.data));
    } else {
      const errorMsg = response.message || response.error || 'Failed to get driver on call package';
      console.error('Driver package API error response:', response);
      yield put(driverOnCallPackageFailure(errorMsg));
    }
  } catch (error: any) {
    console.error('Driver package API exception:', error);
    const errorMsg = error?.response?.data?.message || 
                    error?.response?.data?.error ||
                    error?.response?.status === 404 ? 'API endpoint not found. Please contact support.' :
                    error?.message || 
                    error?.toString() ||
                    'Failed to get driver on call package';
    console.error('Driver package API error message:', errorMsg);
    yield put(driverOnCallPackageFailure(errorMsg));
  }
}

// On Call Package Buy Handler
export function* handlerOnCallPackageBuUpload(action: any): Generator<any, void, any> {
  try {
    yield put(drivingOnCallPackageBuyLoading());
    const response: any = yield call(postHttpwithtoken, `${urls.baseURL}${urls.packagepay}`, action.payload);
    
    if (response.success) {
      yield put(drivingOnCallPackageBuySuccess(response.data));
    } else {
      yield put(drivingOnCallPackageBuyFailure(response.message || 'Failed to buy package'));
    }
  } catch (error: any) {
    yield put(drivingOnCallPackageBuyFailure(error.message || 'Failed to buy package'));
  }
}

// Customer Call Detail List Handler
export function* handlerCustomerCallDetailList(action: any): Generator<any, void, any> {
  try {
    yield put(customerCallListLoading());
    const url = `${urls.baseURL}${urls.customerCallList}`;
    console.log('Fetching customer call list from:', url);
    const response: any = yield call(getHttpwithtoken, url);
    
    console.log('Customer call list API response:', response);
    
    if (response.success) {
      yield put(customerCallListSuccess(response.data));
    } else {
      const errorMsg = response.message || response.error || 'Failed to get customer call list';
      console.error('Customer call list API error response:', response);
      yield put(customerCallListFailure(errorMsg));
    }
  } catch (error: any) {
    console.error('Customer call list API exception:', error);
    const errorMsg = error?.response?.data?.message || 
                    error?.response?.data?.error ||
                    error?.response?.status === 404 ? 'API endpoint not found. Please contact support.' :
                    error?.message || 
                    error?.toString() ||
                    'Failed to get customer call list';
    console.error('Customer call list API error message:', errorMsg);
    yield put(customerCallListFailure(errorMsg));
  }
}
